import { UserType } from 'types';

export const userTypesWithoutMessagesModule: UserType[] = ['SYS_ADMIN', 'SUPPORT_OWNER'];
